export enum SentryFeatureTags {
  AI = "AI",
  Auth = "Auth",
  Checkout = "Checkout",
  DeveloperApi = "DeveloperApi",
  Comedian = "Comedian",
  ComedianDigest = "ComedianDigest",
  Specials = "Specials",
  ComedianVideoUploader = "ComedianVideoUploader",
  Email = "Email",
  Feed = "Feed",
  FreeSubscriptions = "FreeSubscriptions",
  Messaging = "Messaging",
  Metrics = "Metrics",
  Recommendations = "Recommendations",
  RouteGuards = "RouteGuards",
  SentryTest = "SentryTest",
  Southpaw = "Southpaw",
  SocialCrossposting = "SocialCrossposting",
  Stripe = "Stripe",
  Subscriptions = "Subscriptions",
  UsersCount = "UsersCount",
  VenueManager = "VenueManager",
  Venues = "Venues",
  VenuePages = "VenuePages",
  ComedianManager = "ComedianManager",
  GoogleMaps = "GoogleMaps",
  Moderation = "Moderation",
  Newsletter = "Newsletter",
  GoogleAds = "GoogleAds",
  GoogleAnalytics = "GoogleAnalytics",
  Notifications = "Notifications",
  TourDates = "TourDates",
  ErrorBoundary = "ErrorBoundary",
  Podcasts = "Podcasts",
  ReleaseBoard = "ReleaseBoard",
  SupportAssistant = "SupportAssistant",
}
